import moment from 'moment'
import 'moment/min/locales'

// set global moment locale
const locale = window.navigator.userLanguage || window.navigator.language
moment.locale(locale)

export const ENV = process.env.REACT_APP_NODE_ENV === 'local' ? 'local' : process.env.REACT_APP_ENV
export const isLocal = ENV === 'local'
export const isProduction = ENV === 'production'
const isHostedDev = ENV === 'dev' && process.env.REACT_APP_HOSTED_DEV === 'true'

export const TOKEN_KEY = 'business_token_guyey'

export const PATH_API_BASE = isLocal
  ? 'http://127.0.0.1:8081'
  : isHostedDev
  ? 'https://business-api.dev.glfr.com'
  : isProduction
    ? 'https://business-api.glfr.com'
    : 'https://business-api.staging.glfr.com'

export const PATH_WEBLATE_PROXY = isLocal
  ? 'http://127.0.0.1:8084'
  : isHostedDev
  ? 'https://weblate-proxy.staging.glfr.com'
  : isProduction
    ? 'https://weblate-proxy.glfr.com'
    : 'https://weblate-proxy.staging.glfr.com'

export const newHost = PATH_API_BASE

export const PATH_GLFR_API = isLocal
  ? 'http://127.0.0.1:8080'
  : isHostedDev
  ? 'https://api.dev.glfr.com'
  : isProduction
    ? 'https://api.glfr.com'
    : 'https://api.staging.glfr.com'


const getGQLPath = () => {
  if (isLocal) {
    return 'http://127.0.0.1:8081/graphql'
  }
  // Outside production REACT_APP_BUSINESS_GRAPHQL_PATH can point at a local business-be, e.g. http://localhost:8090/graphql
  if (!isProduction && process.env.REACT_APP_BUSINESS_GRAPHQL_PATH) {
    return process.env.REACT_APP_BUSINESS_GRAPHQL_PATH
  }
  switch (ENV) {
    case 'production':
      return 'https://business-be.glfr.com/graphql'
    case 'staging':
      return 'https://business-be.staging.glfr.com/graphql'
    case 'dev':
      return isHostedDev ? 'https://business-be.dev.glfr.com/graphql' : 'http://localhost:8080/graphql'
    default:
      return 'https://business-be.staging.glfr.com/graphql'
    }
}

export const PATH_GRAPHQL = getGQLPath()
export const PATH_BUSINESS_BE_BASE = PATH_GRAPHQL.replace(/\/graphql$/, '')

const getKioskBaseUrl = () => {
  switch (ENV) {
    case 'local':
      return 'http://127.0.0.1:3002/'
    case 'production':
      return "https://kiosk.glfr.com/"
    case 'staging':
      return "https://kiosk.staging.glfr.com/"
    case 'dev':
      return isHostedDev ? 'https://kiosk.dev.glfr.com/' : 'https://kiosk.staging.glfr.com/'
    default:
      return "https://kiosk.staging.glfr.com/"
  }
}

export const KIOSK_BASE_URL = getKioskBaseUrl()

const bucket = function () {
  if (isLocal) {
    return 'ingo-dev'
  }
  if (process.env.REACT_APP_S3_BUCKET) {
    return process.env.REACT_APP_S3_BUCKET
  }

  switch (ENV) {
    case 'production':
      return 'ingo-prod'
    case 'staging':
      return 'ingo-staging'
    case 'dev':
      return 'ingo-dev'
    default:
      return 'ingo-staging'
  }
}

export const aws = {
  endpoint: 'https://s3-eu-west-1.amazonaws.com',
  bucket: bucket(),
  tempBucket: 'ingo-temp'
}

export const S3_PATH = aws.endpoint + '/' + aws.bucket + '/'

export const getClubLogo = (clubId) => `${S3_PATH}clubs/round/${clubId}_logo.png`
export const statusImagePath = (clubId) => (imageId) => `${S3_PATH}images/status/${clubId}/${imageId}.jpg`
export const newsPostImagePath = (clubId) => (imageId) => `${S3_PATH}images/news/${clubId}/${imageId}.jpg`

export function fileUpload ({ endpoint, token, file, onProgress, onSuccess, onFailure }) {
  // eslint-disable-next-line
  const xhr = new XMLHttpRequest()
  xhr.upload.addEventListener('progress', e => {
    if (e.lengthComputable) {
      const progress = e.loaded / e.total
      onProgress(progress)
    }
  })
  xhr.onreadystatechange = e => {
    const { readyState, status } = xhr
    if (readyState === 4) {
      if (status === 200 || status === 201) {
        onSuccess()
      } else {
        onFailure()
      }
    }
  }
  const completeEndpoint = `${PATH_API_BASE}/${endpoint}`
  xhr.open('POST', completeEndpoint, true)
  if (token) {
    xhr.setRequestHeader('X-Auth-Token', token)
  }
  xhr.send(file)
}

export function fileDelete ({ endpoint, token, onSuccess, onFailure }) {
  // eslint-disable-next-line
  const xhr = new XMLHttpRequest()
  xhr.onreadystatechange = e => {
    const { readyState, status } = xhr
    if (readyState === 4) {
      if (status === 200 || status === 201 || status === 204) {
        onSuccess()
      } else {
        onFailure()
      }
    }
  }
  const completeEndpoint = `${PATH_API_BASE}/${endpoint}`
  xhr.open('DELETE', completeEndpoint, true)
  if (token) {
    xhr.setRequestHeader('X-Auth-Token', token)
  }
  xhr.send()
}

export const awsLocation = aws.endpoint + '/' + aws.bucket + '/'
export const awsTempLocation = () => aws.endpoint + '/' + aws.tempBucket + '/'
export const appClubLogoLocation = awsLocation + 'clubs/round/'
export const printClubLogoLocation = awsLocation + 'clubs/app/'

export const feedClubStatusLocation = (clubHandle = '') => PATH_BUSINESS_BE_BASE + '/feeds/club-status/' + clubHandle
export const feedNewsFeedLocation = (clubHandle = '') => PATH_BUSINESS_BE_BASE + '/feeds/news-feed/' + clubHandle
export const clubsLocation = () => awsLocation + 'clubs/original/'
export const guidesLocation = () => awsLocation + 'guides/'
export const overviewsLocation = () => awsLocation + 'images/overviews/'
export const spritesLocation = () => awsLocation + 'images/sprites/'
export const sponsorsLocation = () => awsLocation + 'images/sponsors/'
export const guidesIconLocation = () => awsLocation + 'images/guides/card/'
export const usersLocation = () => awsLocation + 'users/profile_images/original/'
export const galleryLocation = () => awsLocation + 'images/clubs/card/'
export const webLocation = () => awsLocation + 'images/clubs/web/'
export const digitalGuideLocation = () => awsLocation + 'course-guides/albatross-3/'
export const commentImagesLocation = (clubId, commentId) => (imageId) => awsLocation + `images/comments/thumbnail/${clubId}/${commentId}/${imageId}.png`
export const commentImagesLocationOriginal = (clubId, commentId) => (imageId) => awsLocation + `images/comments/original/${clubId}/${commentId}/${imageId}.png`
export const profilesPictureLocation = () => awsLocation + "glfr/pictures/"
